import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '../../../auth/auth.service';
import { NotifyService } from '../../../common/notify/notify.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialogModule } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { FormsModule, NgModel } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { ParticipantService } from '../../../services/participant.service';
import { Recipient } from '../../../interfaces/recipient';
import { Approval, ApprovalColumn, ApprovalColumnLabels, ApprovalStatus } from '../../../interfaces/approval';

@Component({
  selector: 'app-request-privilege',
  imports: [MatDialogModule, MatFormFieldModule, CommonModule, ReactiveFormsModule, FormsModule, MatOptionModule, MatSelectModule, MatInputModule],
  providers: [NotifyService],
  templateUrl: './request-privilege.component.html',
  styleUrl: './request-privilege.component.scss'
})
export class RequestPrivilegeComponent {
  constructor(
    private readonly authService: AuthService,
    private readonly participantService: ParticipantService,
    private readonly ref: MatDialogRef<RequestPrivilegeComponent>,
    private readonly notify: NotifyService,
    private readonly cdr: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) readonly recipient: Recipient
  ) {
    this.privileges = Object.values(ApprovalColumn).filter((privilege) => privilege !== ApprovalColumn.PRIORITY); // Get enum keys
  }

  privileges = Object.values(ApprovalColumn); // Get enum keys
  approvalColumnLabels = ApprovalColumnLabels; // Label mapping
  selectedPrivilege: ApprovalColumn | null = null;
  approval: Approval | null = null;

  value?: string;
  approvalReason?: string;
  showValueInput = false;
  showTextInput = false;
  showCheckboxInput = false;

  onPrivilegeChange() {
    switch (this.selectedPrivilege) {
      case ApprovalColumn.PRIORITY:
        this.showValueInput = false;
        this.value = undefined;
        break;
      // case ApprovalColumn.EXTRAWAITTIME:
      //   this.showValueInput = true;
      //   this.showTextInput = false;
      //   this.showCheckboxInput = true;
      //   this.value = 'true';
      //   this.cdr.detectChanges();
      //   break;
      default:
        this.showValueInput = true;
        this.showTextInput = true;
        this.showCheckboxInput = false;
        this.value = '';
        break;
    }
    // Trigger change detection to ensure the view updates
    this.cdr.detectChanges();
  }

  async apply() {
    // PM waitlist patients cannot have privileges
    if (this.recipient.postmortumwaitlist === true) {
      this.notify.withAutodismiss('PM waitlist patients cannot have privileges. Register as Crossover participant instead.');
      this.ref.close({ success: false });
      return;
    }

    const privilege = this.selectedPrivilege;
    if (privilege) {
      this.approval = {
        approvalColumn: privilege,
        value: this.value,
        approvalReason: this.approvalReason,
        recipient: this.recipient,
        status: ApprovalStatus.PENDING
      };

      this.participantService.createApprovalRequestForPrivileges(this.approval).subscribe({
        next: (result) => {
          this.notify.withAutodismiss(`Added privilege: "${this.selectedPrivilege}" for recipient ${this.recipient.id}`);
          this.ref.close({ success: true, result });
        },
        error: (err) => {
          console.log(err);
          this.notify.withAutodismiss('Failed to add privilege. Please try again.');
          this.ref.close({ success: false, error: err });
        }
      });
    }
  }
  isNumericInput(privilege: ApprovalColumn | null): boolean {
    return privilege === ApprovalColumn.MAXDONORAGE || privilege === ApprovalColumn.MAXMISMATCHES;
  }
  cancel() {
    this.ref.close(false);
  }
}
